import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalyticsWithConsent } from '../../hooks/useAnalyticsWithConsent';
import { useAuth } from '../../auth/firebaseAuth';

const RouteTracker = () => {
  const location = useLocation();
  const analytics = useAnalyticsWithConsent();
  const { currentUser } = useAuth();

  return null;
  
  // useEffect(() => {
  //   // Track page view to both Facebook Pixel & Reddit Pixel with consent management
  //   analytics.trackPixelPageView({
  //     email: currentUser?.email || undefined,
  //     externalId: currentUser?.uid,
  //   });
  // }, [location, analytics, currentUser]);

  // return null;
};

export default RouteTracker;
